import * as EmailValidator from 'email-validator';
import { z } from 'zod';

import {
  FULL_NAME_ERROR_MESSAGE,
  INCORRECT_FORMAT_MESSAGE,
  PHONE_REGEX,
  REQUIRED_FIELD_MESSAGE,
} from './constants';

export enum LoginInputName {
  EMAIL = 'email',
  PHONE = 'phone',
}

const nonEmptyStringValidator = z
  .string()
  .trim()
  .nonempty(REQUIRED_FIELD_MESSAGE);

export const emailValidator = {
  email: nonEmptyStringValidator.refine(
    (email) => EmailValidator.validate(email),
    INCORRECT_FORMAT_MESSAGE('email address')
  ),
};

export const phoneValidator = {
  phone: nonEmptyStringValidator.regex(
    PHONE_REGEX,
    INCORRECT_FORMAT_MESSAGE('US phone number')
  ),
};

export const fullNameValidator = {
  fullName: z
    .string()
    .trim()
    .refine((name) => {
      const [first, ...last] = name.trim().split(' ');

      return first.length > 0 && last.join('').length > 0;
    }, FULL_NAME_ERROR_MESSAGE),
};
